import { render } from "./EditSite.vue?vue&type=template&id=688f5b6b&ts=true"
import script from "./EditSite.vue?vue&type=script&lang=ts"
export * from "./EditSite.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__